<template>
  <service-view
    :pictures="pictures"
    :serviceTitle="serviceTitle"
    :electricalActive="'active'"
    :serviceDescription="serviceDescription"
  />
</template>
<script>
import ServiceView from "./ServiceView";
export default {
  name: "electrical",
  components: {
    ServiceView
  },
  data: () => ({
    pictures: [
      {
        name: "electrical/electrical.jpg",
        title: "Constructing a factory",
        location: "Zambia"
      },
      {
        name: "electrical/electrical1.jpg",
        title: "Swimming pool construction",
        location: "Zambia"
      }
    ],
    serviceTitle: "Electrical",
    serviceDescription:
      "At Johnson styles construction we offer a diverse range like troubleshooting, Wiring, installations, maintenance for residential, commercial and industrial markets, in Zambia and all over the world"
  })
};
</script>
